export const ABNORMAL_RECORD_PAGE_UUID = 'ce7d7921-9752-47b8-8b2b-dc5ffbdf5477'
